import React from 'react';
import { Fade } from 'react-awesome-reveal';

import {
  Container,
  WysiwygField,
} from '../../../components';

import './style.scss';

const Content = ({ entity, containerless, onAnswerPage }) => {
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;

  if (containerless) {
    return (
      <Fade triggerOnce bottom distance="50px" duration={500} className="Paragraph">
        <WysiwygField
          id={paragraphKey}
          property="schema:text"
          className="ParagraphContent"
          html={entity.getIn(['field_body', 0, 'processed'])}
        />
      </Fade>
    );
  }

  return (
    <Container id={paragraphKey} className="mt-4 mb-4 Paragraph">
      <div className={`${!onAnswerPage && 'row'}`}>
        <div className={`${!onAnswerPage && 'col-12 col-lg-8 offset-lg-2'}`}>
          <Fade triggerOnce bottom distance="50px" duration={500}>
            <WysiwygField
              property="schema:text"
              className="ParagraphContent ParagraphContent--large"
              html={entity.getIn(['field_body', 0, 'processed'])}
            />
          </Fade>
        </div>
      </div>
    </Container>
  );
};

export default Content;

